import { Mail, Phone } from "lucide-react";
import { Reveal } from "@/components/landing/Reveal";

const SHOTS = [
  { src: "/screenshots/welcome.png", alt: "Splurge app welcome screen" },
  { src: "/screenshots/home.png", alt: "Splurge app home dashboard" },
  { src: "/screenshots/comparison.png", alt: "Splurge app Impact Calculator comparison tab" },
  { src: "/screenshots/wishlist.png", alt: "Splurge app wishlist tab" },
];

const FOUNDERS = [
  {
    initials: "RP",
    slug: "ranvirr",
    name: "Ranvirr Pardasani",
    role: "Co-founder",
    email: "pardasani.ranvirr@gmail.com",
    phone: "+91 98200 32894",
    phoneHref: "+919820032894",
  },
  {
    initials: "RA",
    slug: "rajveer",
    name: "Rajveer Agrawal",
    role: "Co-founder",
    email: "jbcnrajveer@gmail.com",
    phone: "+91 99878 91714",
    phoneHref: "+919987891714",
  },
];

export const PressKit = () => {
  return (
    <section id="press-kit" className="scroll-mt-20 bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="text-xs font-extrabold uppercase tracking-[0.22em] text-splurge-primary">
            Press kit
          </p>
        </Reveal>
        <div className="mt-4 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <Reveal delay={80}>
            <h2 className="max-w-2xl text-4xl font-extrabold leading-[1.08] tracking-tight text-splurge-ink sm:text-5xl">
              Everything you need to write about{" "}
              <span className="text-splurge-primary">Splurge.</span>
            </h2>
          </Reveal>
          <Reveal delay={160}>
            <p className="max-w-md text-base leading-relaxed text-splurge-ink/60 md:text-lg">
              Official app screenshots and founder details, packaged for media and creators.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-5 md:grid-cols-2">
          <Reveal delay={100}>
            <article
              data-testid="press-card-screenshots"
              className="flex h-full flex-col rounded-3xl border border-splurge-lavender bg-splurge-bg p-8"
            >
              <h3 className="text-lg font-extrabold tracking-tight text-splurge-ink">
                App screenshots
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-splurge-ink/60">
                Official screens from the live iPhone app.
              </p>
              <div className="mt-6 grid flex-1 grid-cols-4 gap-2.5">
                {SHOTS.map((shot) => (
                  <img
                    key={shot.src}
                    src={shot.src}
                    alt={shot.alt}
                    loading="lazy"
                    className="w-full rounded-xl ring-1 ring-splurge-lavender"
                  />
                ))}
              </div>
            </article>
          </Reveal>

          <Reveal delay={200}>
            <article
              data-testid="press-card-founders"
              className="flex h-full flex-col rounded-3xl border border-splurge-lavender bg-splurge-bg p-8"
            >
              <h3 className="text-lg font-extrabold tracking-tight text-splurge-ink">Founders</h3>
              <p className="mt-2 text-sm leading-relaxed text-splurge-ink/60">
                Splurge is built by two founders helping a new generation understand peer
                pressure, group spending, and the financial impact of everyday social choices.
              </p>
              <ul className="mt-6 flex-1 space-y-3">
                {FOUNDERS.map((founder) => (
                  <li
                    key={founder.name}
                    className="flex items-start gap-4 rounded-2xl bg-white p-4 ring-1 ring-splurge-lavender"
                  >
                    <span
                      aria-hidden="true"
                      className="grid h-12 w-12 shrink-0 place-items-center rounded-full bg-gradient-to-br from-splurge-primary to-splurge-dark text-sm font-extrabold text-white"
                    >
                      {founder.initials}
                    </span>
                    <div className="min-w-0">
                      <p className="text-base font-extrabold text-splurge-ink">{founder.name}</p>
                      <p className="text-sm font-semibold text-splurge-ink/50">{founder.role}</p>
                      <div className="mt-2.5 space-y-1.5">
                        <a
                          href={`mailto:${founder.email}`}
                          data-testid={`founder-email-${founder.slug}`}
                          aria-label={`Email ${founder.name}`}
                          className="flex items-center gap-2 break-all text-sm font-semibold text-splurge-ink/60 transition-colors hover:text-splurge-primary"
                        >
                          <Mail className="h-3.5 w-3.5 shrink-0 text-splurge-primary" aria-hidden="true" />
                          {founder.email}
                        </a>
                        <a
                          href={`tel:${founder.phoneHref}`}
                          data-testid={`founder-phone-${founder.slug}`}
                          aria-label={`Call ${founder.name}`}
                          className="flex items-center gap-2 text-sm font-semibold text-splurge-ink/60 transition-colors hover:text-splurge-primary"
                        >
                          <Phone className="h-3.5 w-3.5 shrink-0 text-splurge-primary" aria-hidden="true" />
                          {founder.phone}
                        </a>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </article>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
